import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vendor-courses',
  templateUrl: './vendor-courses.component.html',
  styleUrls: ['./vendor-courses.component.scss']
})
export class VendorCoursesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
